import React from 'react';

interface BlogImagePlaceholderProps {
  category?: string;
  className?: string;
}

const BlogImagePlaceholder: React.FC<BlogImagePlaceholderProps> = ({ category = 'default', className = '' }) => {
  const categoryColors = {
    'Market Insights': 'from-blue-400 to-blue-600',
    'Company Updates': 'from-green-400 to-green-600',
    'Industry Analysis': 'from-purple-400 to-purple-600',
    'Educational': 'from-orange-400 to-orange-600',
    'Regulatory Updates': 'from-red-400 to-red-600',
    'Market Analysis': 'from-indigo-400 to-indigo-600',
    'default': 'from-gray-400 to-gray-600'
  };

  const categoryIcons = {
    'Market Insights': '📈',
    'Company Updates': '🏢',
    'Industry Analysis': '🔍',
    'Educational': '📚',
    'Regulatory Updates': '⚖️',
    'Market Analysis': '📊',
    'default': '📄'
  };

  const gradient = categoryColors[category as keyof typeof categoryColors] || categoryColors.default;
  const icon = categoryIcons[category as keyof typeof categoryIcons] || categoryIcons.default;

  return (
    <div className={`bg-gradient-to-br ${gradient} flex items-center justify-center ${className}`}>
      <span className="text-6xl opacity-50 text-white">{icon}</span>
    </div>
  );
};

export default BlogImagePlaceholder; 